import * as models from '@owl-nest/models'
import * as api from '@owl-nest/api-client/next'

import { type Location } from '@ulule/duvet/LocationPicker.tsx'

const LOCALSTORAGE_NAME_CART = 'ul_checkout_cart_v3_'

type SelectedMondialRelay = {
  address: api.BaseAddress & { longitude: number; latitude: number }
  firstName: string
  lastName: string
  phoneNumber: string
  dropoff: Location
}

export type CartState = {
  project?: api.Project
  dryRunResult?: api.Order

  isLoading: boolean
  shipping: {
    mode?: api.ShippingMode
    country?: { code: string; forced: boolean }
    pickupPoint?: number
    mondialRelay?: Partial<SelectedMondialRelay>
    error: boolean
    billingAddress?: number
    shippingAddress?: number
  }
  tip: {
    frequency?: models.project.DonationFrequency
    amount?: number
  }
  products: { id: number; parentId?: number; quantity: number; valuesIds?: number[] }[]
}

export function getCartFromLocalStorage(projectId: number): CartState | undefined {
  const storage = window.localStorage
  const stored = storage.getItem(`${LOCALSTORAGE_NAME_CART}${projectId}`)

  if (stored) {
    const data = JSON.parse(stored)
    return data.cartState
  }

  return undefined
}

export function setCartInLocalStorage(projectId: number, cartState: CartState, expirationDate: number): void {
  const storage = window.localStorage

  storage.setItem(
    `${LOCALSTORAGE_NAME_CART}${projectId}`,
    JSON.stringify({
      cartState,
      expirationDate,
    }),
  )
}

export function removeCartFromLocalStorage(projectId: number): void {
  const storage = window.localStorage
  storage.removeItem(`${LOCALSTORAGE_NAME_CART}${projectId}`)
}

export function getAllCarts(): Array<{ cartState: CartState; expirationDate: string }> {
  const storage = window.localStorage
  return Object.keys(storage)
    .filter((key) => key.startsWith(LOCALSTORAGE_NAME_CART))
    .map((key) => {
      const stored = storage.getItem(key)
      return stored ? JSON.parse(stored) : null
    })
    .filter((cart) => cart !== null) as Array<{ cartState: CartState; expirationDate: string }>
}

export function getCartExpirationDate(projectId: number): number | undefined {
  const storage = window.localStorage
  const stored = storage.getItem(`${LOCALSTORAGE_NAME_CART}${projectId}`)

  if (stored) {
    const data = JSON.parse(stored)
    return data.expirationDate
  }

  return undefined
}
